const statuses = [
  { value: null, label: 'Все' },
  { value: 'opened', label: 'В работе' },
  { value: 'delayed', label: 'Отложено' },
  { value: 'completed', label: 'Решено' },
  { value: 'closed', label: 'Закрыто' },
];

export default statuses;
